import type { Content } from '@/modules/Content/interface/Content';
import type { FC } from 'react';
import { Box } from '@eqi-investimentos/react';

export const AboutSection: FC<AboutSectionProps> = ({ content }) => (
  <Box
    color="content.primary"
    dangerouslySetInnerHTML={{ __html: content?.summary ?? '' }}
  />
);

type AboutSectionProps = {
  content?: Content;
};
